const styles = {
  nav: {
    padding: '12px 10px 4px',
    fontSize: '14px'
  },
  link: {
    color: '#3f51b5',
    textDecoration: 'none'
  },
  separator: {
    margin: '0 8px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  current: {
    color: 'rgba(0, 0, 0, 0.87)'
  }
};

export default styles;
